<template>
  <a-card :bordered="false">

    <!-- 查询区域-END -->

    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="queryChange">
        <a-row :gutter="24">
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <a-form-item  :label="$t('label.batchNo')">
              <j-input :placeholder="$t('label.pleaseSelectBatchNo')" v-model="queryParam.breedBatchCode"></j-input>
            </a-form-item>
          </a-col>
          <a-col :xl="6" :lg="7" :md="8" :sm="24">
            <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
              <a-button type="primary" @click="queryChange" icon="search">查询</a-button>
              <a-button type="primary" @click="searchReset" icon="reload" style="margin-left: 8px">重置</a-button>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <!-- table区域-begin -->
    <div>


      <a-table
        ref="table"
        size="middle"
        :scroll="{x:true}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        :rowSelection="{selectedRowKeys: selectedRowKeys, onChange: onSelectChange}"
        class="j-table-force-nowrap"
        @change="handleTableChange">





      </a-table>
    </div>


  </a-card>
</template>

<script>

    import '@/assets/less/TableExpand.less'
    import { mixinDevice } from '@/utils/mixin'
    import { JeecgListMixin } from '@/mixins/JeecgListMixin'
    import {getAction} from '@/api/manage'
    import JDictSelectTag from "@/components/dict/JDictSelectTag"
    import JInput from '@/components/jeecg/JInput'

    export default {
        name: 'EfsPayableList',
        mixins:[JeecgListMixin],
        components: {
            JDictSelectTag,
            JInput
        },
        data () {
            return {
                description: '应付单',
                // 表头
                columns: [
                    {
                        title: '#',
                        dataIndex: '',
                        key:'rowIndex',
                        width:60,
                        align:"center",
                        customRender:function (t,r,index) {
                            return parseInt(index)+1;
                        }
                    },
                    {
                                    slotName: 'tableHeader.company',
            scopedSlots: { title: 'tableHeader.company'},
                        align:"center",
                        dataIndex: 'companyCode_dictText'
                    },
                    {
                        title:'会计期间',
                        align:"center",
                        dataIndex: 'accountCode'
                    },
                    {
                        slotName: 'tableHeader.feedingLot',
                        scopedSlots: { title: 'tableHeader.feedingLot'},
                        align:"center",
                        dataIndex: 'breedBatchCode'
                    },
                    {
                        slotName: 'tableHeader.status',
            scopedSlots: { title: 'tableHeader.status'},
                        align:"center",
                        dataIndex: 'status',
                        customRender:function (text) {
                            if(text=='10'){
                                return "在养";
                            }else if(text=='20'){
                                return "已结算";
                            }

                        }
                    },
                    {
                        slotName: 'tableHeader.breed',
            scopedSlots: { title: 'tableHeader.breed'},
                        align:"center",
                        dataIndex: 'breedClassCode_dictText'
                    },
                    {
                        slotName: 'tableHeader.serviceGroup',
            scopedSlots: { title: 'tableHeader.serviceGroup'},
                        align:"center",
                        dataIndex: 'groupCode_dictText'
                    },
                    {
                        title:'存栏合计',
                        align:"center",
                        dataIndex: 'totalDailyInventory'
                    },
                    {
                        title:'每只每日代养费标准',
                        align:"center",
                        dataIndex: 'substituteSupport'
                    },
                    {
                        title:'每只每日分红标准',
                        align:"center",
                        dataIndex: 'dividends'
                    },
                    {
                        title:'代养费和分红金额',
                        align:"center",
                        dataIndex: 'totalAmount'
                    },
                    {
                        title:'pk值',
                        align:"center",
                        dataIndex: 'pk'
                    },
                    {
                        title:'冲销pk值',
                        align:"center",
                        dataIndex: 'pkReversal'
                    }
                ],
                url: {
                    list: "/certificateManage/efsCapCertificate/list",

                },
                dictOptions:{},
            }
        },
        created() {
        },
        computed: {
            importExcelUrl: function(){
                return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
            },
        },
        methods: {
            loadData(arg) {
                if (arg === 1) {
                    this.ipagination.current = 1;
                }
                var params = this.getQueryParams();
                if(params.company){
                    getAction(this.url.list, {breedBatchCode:params.breedBatchCode,companyCode:params.company,accountCode:params.period, pageNo : this.ipagination.current,
                        pageSize :this.ipagination.pageSize}).then((res) => {
                        if (res.success) {
                            this.dataSource = res.result.records;
                            this.ipagination.total = res.result.total;
                        } else {
                            this.dataSource = null;
                        }
                    })
                }

            },
            getOrderMain(company,period) {
                this.queryParam.company = company;
                this.queryParam.period = period;
                this.loadData(1);
            },
            searchReset(){
                this.queryParam.breedBatchCode="";
                this.loadData(1);
            },
            queryChange(){
                this.loadData(1);
            },
            initDictConfig(){
            }
        }
    }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>